<template>
  <div>
    <template v-if="isImage() === true">
      <v-img
        class="imageButton"
        :alt="element.caption"
        :src="getImgUrl(element.icon)"
        >
      </v-img>
    </template>
    <template v-else-if="isText() === true">
      <span>{{element.caption}}</span>
    </template>
    <template v-else-if="isTextArea() === true">
      <v-textarea
        outlined
        name="input-7-4"
        label="Mensaje"
      >{{element.value}}</v-textarea>
    </template>
  </div>
</template>
<script>
  export default {
    props: {
      element: {
        type: Object,
        default: () => ({
          type: 'text', // text | image
          caption: 'test', // Text | url
          value: 'value',
          icon: 'icon'
        })
      }
    },
    data: () => ({
      enabled: false
    }),
    methods: {
      isImage: function () {
        return this.element.type === 'image'
      },
      isTextArea: function () {
        return this.element.type === 'textArea'
      },
      isText: function () {
        return this.element.type === 'text'
      },
      setValue: function (value) {
        this.state = value
      },
      setEnable: function (value) {
        this.enabled = value
      },
      getImgUrl: (value) => {
        var images = require.context('@/assets/img/buttons', false)
        return images('./' + value)
      },
      propagateChange: function () {
        this.$emit('selectedElement',
          { value: this.element }
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/diaryElements/BasicButton.vue